/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcSettingOnRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M20 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
      <path d="M20.1 8.799V19a1.1 1.1 0 0 1-1.1 1.1H5A1.1 1.1 0 0 1 3.9 19V5A1.1 1.1 0 0 1 5 3.9h10.2c.013-.638.15-1.246.39-1.8H5A2.9 2.9 0 0 0 2.1 5v14A2.9 2.9 0 0 0 5 21.9h14a2.9 2.9 0 0 0 2.9-2.9V8.41a4.8 4.8 0 0 1-1.8.389" />
      <path d="M9 6.1a.9.9 0 0 1 .9.9v2.1h.6a.9.9 0 1 1 0 1.8h-.6V17a.9.9 0 0 1-1.8 0v-6.1h-.6a.9.9 0 0 1 0-1.8h.6V7a.9.9 0 0 1 .9-.9m4.5 7a.9.9 0 0 0 0 1.8h.6V17a.9.9 0 0 0 1.8 0v-2.1h.6a.9.9 0 0 0 0-1.8h-.6V7a.9.9 0 1 0-1.8 0v6.1z" />
    </svg>
  );
}
export default IcSettingOnRegular;
